import React, { useState, useEffect } from 'react';
import Table, { columnType } from '../../../components/ClearingTable/Table';

export default function ClientSummaryTradeTable({ value }) {
  const [rows, setRows] = useState([]);

  const columns = [
    {
      name: 'entryType',
      label: 'Entry Type',
    },
    {
      name: 'systemDate',
      label: 'System Date',
      type: columnType.date,
    },
    {
      name: 'tradeDate',
      label: 'Trade Date',
      type: columnType.date,
    },
    {
      name: 'settleDate',
      label: 'Settle Date',
      type: columnType.date,
    },
    {
      name: 'symbol',
      label: 'Symbol',
    },
    {
      name: 'side',
      label: 'Side',
    },
    {
      name: 'cusip',
      label: 'Cusip',
    },
    {
      name: 'symbolDescription',
      label: 'Symbol Description',
    },
    {
      name: 'qty',
      label: 'Qty',
      type: columnType.quantity,
    },
    {
      name: 'price',
      label: 'Price',
      type: columnType.price,
    },
    {
      name: 'grossAmt',
      label: 'Gross Amount',
      type: columnType.amount,
    },
    {
      name: 'regFee',
      label: 'Reg Fee',
      type: columnType.amount,
    },
    {
      name: 'tafFee',
      label: 'Taf Fee',
      type: columnType.amount,
    },
    {
      name: 'fees',
      label: 'Fees',
      type: columnType.amount,
    },
    {
      name: 'netAmt',
      label: 'Net Amount',
      type: columnType.amount,
    },
    {
      name: 'description',
      label: 'Description',
      type: columnType.note,
    },
    {
      name: 'status',
      label: 'Status',
    },
    {
      name: 'a-selectAll',
      label: 'Select All',
      options: {
        display: true,
        print: false,
        download: false,
        filter: false,
        setCellHeaderProps: () => ({
          style: {
            width: '0px',
            display: 'table-cell',
            padding: 0,
            pointerEvents: 'none',
            fontSize: 0,
          },
        }),
      },
    },
  ];

  const options = {
    selectableRows: 'none',
    responsive: 'standard',
  };

  useEffect(
    () => {
      setRows(value);
    }, // eslint-disable-next-line
    [value]
  );

  return <Table title="TRADE" data={rows} columns={columns} options={options} />;
}
